import { validationMessages } from './validationMessages.schema';

export default {
  title: 'metadata',
  type: 'object',
  fieldRequired: false,
  properties: {
    signature: {
      type: 'object',
      fieldRequired: false,
      properties: {
        signedBy: {
          type: 'string',
          fieldRequired: false
        },
        validity: {
          type: 'object',
          properties: {
            notAfter: {
              type: 'string',
              fieldRequired: false
            },
            notBefore: {
              type: 'string',
              fieldRequired: false
            }
          }
        }
      }
    },
    content: {
      type: 'object',
      fieldRequired: false,
      properties: {
        mediaId: {
          type: 'number',
          fieldRequired: false
        },
        attachmentId: {
          type: 'number',
          fieldRequired: false
        }
      }
    },
    edit: {
      type: 'object',
      fieldRequired: false,
      properties: {
        editable: {
          type: 'boolean',
          fieldRequired: false
        },
        html: {
          type: 'string',
          fieldRequired: false
        },
        htmls: {
          type: 'array',
          items: {
            type: 'string'
          }
        }
      }
    },
    zip: {
      type: 'boolean',
      fieldRequired: false,
      default: false
    },
    contest: { type: 'string', fieldRequired: false },
    mdokUid: { type: 'number', fieldRequired: false },
    mdokJoUid: { type: 'number', fieldRequired: false },
    data: {
      type: 'object',
      fieldRequired: false,
      properties: {
        documentValues: {
          type: 'array',
          items: {
            type: 'string'
          }
        }
      }
    }
  },
  allOf: [validationMessages]
};
